import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import scrollama from "scrollama";
import classNames from "classnames";
import debounce from "lodash/debounce";
import Chapter from "./components/Chapter";

var ChapterNavInner = /*#__PURE__*/function (_Component) {
  _inherits(ChapterNavInner, _Component);

  var _super = _createSuper(ChapterNavInner);

  function ChapterNavInner(props) {
    var _this;

    _classCallCheck(this, ChapterNavInner);

    _this = _super.call(this, props);
    _this.getClassName = getClassNameFactory("LongformChapterNavInner");
    var chapters = ChapterNavInner.getChapters(props.children);
    _this.state = {
      currentChapterIndex: ChapterNavInner.getCurrentChapter(chapters),
      chapters: chapters,
      expanded: false
    };
    _this.scrollSpyOffset = 0.1;
    _this.resizeDebounceTimeout = 200;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleChapterClick = _this.handleChapterClick.bind(_assertThisInitialized(_this));
    _this.handleStepEnter = _this.handleStepEnter.bind(_assertThisInitialized(_this));
    _this.handleStepExit = _this.handleStepExit.bind(_assertThisInitialized(_this));
    _this.resizeScrollSpy = _this.resizeScrollSpy.bind(_assertThisInitialized(_this));
    _this.resizeScrollSpyDebounced = debounce(_this.resizeScrollSpy, _this.resizeDebounceTimeout).bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ChapterNavInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Run on mount rather than constructor, as page need to have loaded.
      if (this.props.spy && typeof window !== "undefined") {
        this.setupScrollSpy();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.scroller && typeof window !== "undefined") {
        this.scroller.destroy();
        window.removeEventListener("resize", this.resizeScrollSpyDebounced);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      // document.activeElement is IE11 fallback
      var relatedTarget = e.relatedTarget || document.activeElement; // This prevents blurring when the next target is within the chapter nav.

      if (this.ref && relatedTarget && this.ref.contains(relatedTarget)) {
        return;
      }

      this.setState({
        expanded: false
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "handleChapterClick",
    value: function handleChapterClick() {
      this.setState({
        expanded: false
      });
    }
  }, {
    key: "handleStepEnter",
    value: function handleStepEnter(_ref) {
      var element = _ref.element;
      this.setState({
        // Use Math.max to ensure we don't crash if element doesn't exist
        currentChapterIndex: Math.max(this.state.chapters.findIndex(function (chapter) {
          return chapter.href === "#".concat(element.id);
        }), 0)
      });
    }
  }, {
    key: "handleStepExit",
    value: function handleStepExit(_ref2) {
      var direction = _ref2.direction;

      if (direction === "up") {
        this.setState({
          currentChapterIndex: Math.max(0, this.state.currentChapterIndex - 1)
        });
      }
    }
  }, {
    key: "setupScrollSpy",
    value: function setupScrollSpy() {
      this.scroller = scrollama();
      var chapterDividerClassName = getClassNameFactory("LongformChapterDivider")(); // setup the instance, pass callback functions

      this.scroller.setup({
        step: ".".concat(chapterDividerClassName),
        offset: this.scrollSpyOffset
      }).onStepEnter(this.handleStepEnter).onStepExit(this.handleStepExit);
      window.addEventListener("resize", this.resizeScrollSpyDebounced);
    }
  }, {
    key: "resizeScrollSpy",
    value: function resizeScrollSpy() {
      this.scroller.resize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          chapters = _this$state.chapters,
          currentChapterIndex = _this$state.currentChapterIndex,
          expanded = _this$state.expanded;
      var currentChapter = chapters[currentChapterIndex];
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          states: classNames({
            expanded: expanded
          })
        }),
        ref: function ref(_ref3) {
          return _this2.ref = _ref3;
        },
        "data-rehydratable": getRehydratableName(ChapterNavInner.displayName),
        "data-spy": this.props.spy ? JSON.stringify(this.props.spy) : null
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "chapterContainer"
        })
      }, /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "currentChapter"
        }),
        onClick: this.handleClick,
        onBlur: this.handleBlur
      }, currentChapter.prefix ? /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "currentChapterPrefix",
          utilities: "typographySmallCaps"
        })
      }, currentChapter.prefix) : null, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "currentChapterTitle"
        })
      }, currentChapter.title), /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "currentChapterIcon"
        })
      }, expanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
        label: "Collapse",
        width: 20
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        label: "Expand",
        width: 20
      }))), /*#__PURE__*/React.createElement("ol", {
        className: this.getClassName({
          descendantName: "chapters"
        }),
        onClick: this.handleChapterClick // Captures bubbled events from links
        ,
        onBlur: this.handleBlur,
        "data-rehydratable-children": true
      }, chapters.map(function (chapter, i) {
        return /*#__PURE__*/React.createElement(Chapter, _extends({
          key: i
        }, chapter, {
          active: currentChapterIndex === i
        }));
      }))));
    }
  }], [{
    key: "getChapters",
    value: function getChapters(children) {
      var chapters = [];
      React.Children.forEach(children, function (child) {
        if (child.type === Chapter) {
          chapters.push(child.props);
        } else if (child.type === React.Fragment) {
          chapters.push.apply(chapters, _toConsumableArray(ChapterNavInner.getChapters(child.props.children)));
        }
      });
      return chapters;
    }
  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter(chapters) {
      return Math.max(chapters.findIndex(function (chapter) {
        return chapter.active === true;
      }), 0);
    }
  }]);

  return ChapterNavInner;
}(Component);

_defineProperty(ChapterNavInner, "displayName", "Longform.ChapterNavInner");

_defineProperty(ChapterNavInner, "propTypes", {
  children: PropTypes.node,
  spy: PropTypes.bool
});

export default ChapterNavInner;